export const GET_LIST_CATEGORIES = 'GET_LIST_CATEGORIES'
export const SET_LIST_VENDORS = 'SET_LIST_VENDORS'
export const SET_LIST_PRODUCTS = 'SET_LIST_PRODUCTS'
export const SET_LIST_BRANDS = 'SET_LIST_BRANDS'
export const SET_LIST_PRICE_TEMPLATES = 'SET_LIST_PRICE_TEMPLATES'
export const SET_LIST_PRODUCT_TAGS = 'SET_LIST_PRODUCT_TAGS'
export const SET_LIST_MEMBER_GROUPS = 'SET_LIST_MEMBER_GROUPS'
export const SET_ADOPTION_MODE = 'SET_ADOPTION_MODE'
export const SET_FILTER_OPTION = 'SET_FILTER_OPTION'
export const SET_COMPLIANCE_LIST = 'SET_COMPLIANCE_LIST'



// WEBPACK FOOTER //
// ./src/types/masterCatalog.js